export default {
  CATEGORIES_EVENT: 'CATEGORIES_EVENT'
}